export function isGreenroomMobileUrl(url?: string): boolean {
  return !!url?.startsWith('greenroom-mobile:');
}

export function isLocalhostUrl(url?: URL | string): boolean {
  if (!url) return false;
  let urlToTest = url;

  if (typeof urlToTest === 'string') {
    urlToTest = new URL(urlToTest);
  }

  return /^localhost:[\d]+$/.test(urlToTest.host);
}
